const { jsbridge } = global;
export const settings = jsbridge.settings;
export const consts = jsbridge.consts;
export const route = jsbridge.route;
export const enums = jsbridge.enums;
export const alertfeed = jsbridge.alertfeed;
export const centralmanager = jsbridge.centralmanager;
export const permissions = jsbridge.permissions;
export default jsbridge;

// noinspection JSAnnotator
/**
 * jsbridge - jsroutes compatibility
 * NOTE: jsroutes is deprecated
 * TODO: remove after jsroutes is not used anymore
 */

window.jsroutes = {};

if (jsbridge !== undefined && jsbridge.route !== undefined) {
  const routes = jsbridge.route.routes;

  Object.keys(routes).forEach(key => {
    window.jsroutes[key] = function deprecatedFunction(args, qsargs) {
      return window.jsbridge.route(key, args, qsargs);
    };
  });
}
